import React from 'react'

import './index.scss'

import Dialog from '../../../Components/Dialog'

export default function AppealDialog(props) {
  // let { visible, setVisible, btns } = props
  return (<div className="AppealDialog">
    <Dialog title="申诉提示" {...props}>
      <p className="content">
        您好，您所申诉的账号需要提供证明材料方可继续进行审核流程。请准备以下材料：身份证明、作品证明（如版权认证等级、工程文件截图，音轨分轨文件任一文件）；若为公司代理申诉的，请提供与所申诉的账号之间关系证明、营业执照。发送至邮箱：tmemusician@tencent.com(标题格式为：歌手名+证明文件+申诉)，我们将有专人联系您。
      </p>
    </Dialog>
  </div>)
}